import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAreas } from "../../../../redux/reducer/areaReducer";
import DetailsRow from "./DetailsRow";
import { useTranslation } from "react-i18next";
import { updateProduct } from "../../../../redux/reducer/productReducer";
import AddBoxForm from "./AddBoxForm";
import GalleryImagesForm from "../../GalleryImagesForm";

const DetailsTable = ({
  details,
  onDelete,
  isGalleryEditing,
  isPricing,
  setEditingOrder,
  setPricingOrder,
  setGalleryEditingOrder,
  refreshData,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { areas, loadingAreas } = useSelector((state) => state.areas);

  // State for AddBox form and edit form
  const [addBoxForm, setAddBoxForm] = useState({
    name: details?.name || "",
    weight: details?.weight || "",
    weightAfterPacking: details?.weightAfterPacking || "",
  });
  // console.log(editForm)
  useEffect(() => {
    dispatch(fetchAreas());
  }, [dispatch]);

  const getLinkButton = (url) => {
    try {
      const hostname = new URL(url).hostname;
      const parts = hostname.split(".");
      const text = parts[1] || hostname;
      return (
        <button
          onClick={() => window.open(url, "_blank")}
          className="px-2 py-1 font-bold text-black duration-300 rounded bg-custom-yellow hover:bg-yellow-200"
        >
          {text}
        </button>
      );
    } catch {
      return "Invalid Link";
    }
  };

  const handleAddBox = () => {
    setAddBoxForm({
      name: details.name,
      weight: details.weight || "",
      weightAfterPacking: details.weightAfterPacking || "",
    });
    setPricingOrder(details.id);
    setEditingOrder(null);
  };

  const handleAddBoxChange = (e) => {
    const { name, value } = e.target;
    setAddBoxForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddBoxSubmit = (e) => {
    e.preventDefault();
    // console.log(priceForm)
    if (!addBoxForm.name || !addBoxForm.weight) {
      alert(t("priceRequired"));
      return;
    }

    // Add default values if they are not already set
    const finalForm = {
      ...addBoxForm,
    };

    // console.log("Final priceForm JSON data:", finalForm);

    dispatch(updateProduct({ id: details.id, data: finalForm }))
      .unwrap()
      .then(() => {
        if (refreshData) refreshData();
      });
    setPricingOrder(null);
  };

  const handleGalleryEdit = () => {
    setGalleryEditingOrder(details.id);
    setEditingOrder(null);
    setPricingOrder(null);
  };

  // console.log(areas)
  return (
    <>
      <DetailsRow
        details={details}
        onDelete={onDelete}
        areas={areas}
        onAddBox={handleAddBox}
        onGallery={handleGalleryEdit}
        getLinkButton={getLinkButton}
      />
      {(isPricing || isGalleryEditing) && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          {isPricing ? (
            <AddBoxForm
              priceForm={addBoxForm}
              onChange={handleAddBoxChange}
              onSubmit={handleAddBoxSubmit}
              onCancel={() => setPricingOrder(null)}
              areas={areas}
              loadingAreas={loadingAreas}
            />
          ) : (
            <GalleryImagesForm
              productId={details.id}
              images={details.images || []}
              refreshData={refreshData}
              onCancel={() => setGalleryEditingOrder(null)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default DetailsTable;
